import { GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';

/** Form schema for the CustomCode component settings in the designer. */
export const CUSTOM_CODE_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
  ],
};
